export default function initializeWCAG() {
    const wcag = new WCAG();
}

class WCAG {
    constructor() {
        this.wcagButtons = document.querySelectorAll('.header-wcag__button');
        this.fontSize = '1';
        this.isHighContrast = false;
        this.init();
    }

    init() {
        this.wcagButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.handleButton(button);
            });
        });

        this.loadPreferences();
        this.updateFooterColumns();
    }

    handleButton(button) {
        const action = button.dataset.action;

        switch (action) {
            case 'defaultFontSize':
                this.setFontSize('1');
                break;
            case 'mediumFontSize':
                this.setFontSize('1.5');
                break;
            case 'largeFontSize':
                this.setFontSize('2');
                break;
            case 'toggleContrast':
                this.toggleContrast();
                break;
            default:
                break;
        }
    }

    setFontSize(scale) {
        this.fontSize = scale;
        document.documentElement.style.setProperty('--font-size-scale', scale);
        document.documentElement.classList.remove('font-size-1', 'font-size-1-5', 'font-size-2');
        document.documentElement.classList.add(`font-size-${scale.replace('.', '-')}`);
        this.updateFooterColumns();  // Aktualizacja kolumn po zmianie rozmiaru czcionki
        this.savePreferences('fontSize', scale);
    }

    updateFooterColumns() {
        const footerSections = document.querySelectorAll('.wcag-bootstrap-change');

        footerSections.forEach(section => {
            const breakpoints = ['lg', 'xl', 'xxl'];
            breakpoints.forEach(breakpoint => {
                section.classList.forEach(className => {
                    if (className.startsWith(`col-${breakpoint}-`)) {
                        section.classList.remove(className);
                    }
                });
            });

            let dataAttribute;
            switch (this.fontSize) {
                case '1':
                    dataAttribute = 'data-wcag-1';
                    break;
                case '1.5':
                    dataAttribute = 'data-wcag-2';
                    break;
                case '2':
                    dataAttribute = 'data-wcag-3';
                    break;
            }

            const newSize = section.getAttribute(dataAttribute);

            breakpoints.forEach(breakpoint => {
                section.classList.add(`col-${breakpoint}-${newSize}`);
            });
        });
    }

    toggleContrast() {
        this.isHighContrast = !this.isHighContrast;

        if (this.isHighContrast) {
            document.body.classList.add('high-contrast');
        } else {
            document.body.classList.remove('high-contrast');
        }

        this.savePreferences('isHighContrast', this.isHighContrast);
    }

    savePreferences(key, value) {
        localStorage.setItem(key, value);
        console.log('Saved preferences:', key, value);
    }

    loadPreferences() {
        const savedFontSize = localStorage.getItem('fontSize');
        const savedContrast = localStorage.getItem('isHighContrast');

        if (savedFontSize) {
            this.setFontSize(savedFontSize);
        } else {
            this.setFontSize(this.fontSize);
        }

        if (savedContrast === 'true') {
            this.isHighContrast = true;
            document.body.classList.add('high-contrast');
        } else {
            this.isHighContrast = false;
            document.body.classList.remove('high-contrast');
        }

        console.log('Loaded preferences:', { fontSize: savedFontSize, isHighContrast: savedContrast });
    }
}
